<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col cols="10">
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.criteria.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="fileSourceList"
            v-model="queryParam.criteria.fileSource"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="invCheckResultList"
            v-model="queryParam.criteria.invCheckResult"
          ></b-form-select>

          <b-form-input
            style="min-width:220px;"
            class="m-1"
            placeholder="提交人/发票号/购方名称"
            v-model="queryParam.criteria.submitter"
          ></b-form-input>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.criteria.daterange"
            style="min-width:200px;"
            placeholder="提交日期"
            class="m-1"
          ></date-range-picker>

          <b-button variant="outline-primary" @click="list(1)" class="m-1">查询</b-button>
        </b-form>
      </b-col>
      <b-col cols="2">
        <!-- <b-button variant="primary" @click="showUploadFileDialog()" class="mr-3 float-right">上传</b-button> -->
        <b-dropdown class="m-1 float-right" left text="上传" variant="primary">
          <b-dropdown-item @click="showUploadFileDialog">本地上传</b-dropdown-item>
          <b-dropdown-item @click="showQrCodeDialog">手机拍照上传</b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive="xl"
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(fileSource)="data">
          <b-badge variant="success" class="mr-2">{{data.value}}</b-badge>
          <b-badge variant="info" v-if="data.item.fileFormat=='PDF'" class="mr-2">PDF</b-badge>
          <b-badge variant="success" v-if="data.item.fileFormat=='OFD'" class="mr-2">OFD</b-badge>
          <b-badge
            variant="warning"
            v-if="data.item.fileFormat!='OFD' && data.item.fileFormat!='PDF'"
            class="mr-2"
          >图片</b-badge>
          <b-badge variant="warning" v-if="data.item.invTags!=null ">{{data.item.invTags}}</b-badge>
        </template>

        <template v-slot:cell(fileSubmitter)="data">
          <span
            v-if="data.item.fileSubmitterName != null && data.item.fileSubmitterName != data.item.fileSubmitter"
          >{{data.item.fileSubmitterName}}&lt;{{data.item.fileSubmitter}}&gt;</span>
          <span
            v-if="data.item.fileSubmitterName != null && data.item.fileSubmitterName == data.item.fileSubmitter"
          >{{data.item.fileSubmitterName}}</span>
          <span v-if="data.item.fileSubmitterName == null">{{data.item.fileSubmitter}}</span>
        </template>

        <template v-slot:cell(fileParseResult)="data">
          <span class="cursor" :id="data.item.id+'/parse'">
            <i :class="getIconClass(data.value)"></i>

            <b-tooltip
              delay="0"
              :target="data.item.id+'/parse'"
              :id="data.item.id+'/parse/tooltip'"
              :variant="getColorClass(data.value)"
              triggers="hover"
              placement="right"
            >{{data.item.fileParseMessage}}</b-tooltip>
          </span>
        </template>

        <template v-slot:cell(invVeriResult)="data">
          <span class="cursor" :id="data.item.id+'/veri'">
            <i :class="getIconClass(data.value)"></i>

            <b-tooltip
              delay="0"
              :target="data.item.id+'/veri'"
              :variant="getColorClass(data.value)"
              triggers="hover"
              placement="right"
            >{{data.item.invVeriMessage}}</b-tooltip>
          </span>
        </template>

        <template v-slot:cell(invCheckResult)="data">
          <span :id="data.item.id+'/check'">
            <i :class="getIconClass(data.value)"></i>
            <b-tooltip
              delay="0"
              :target="data.item.id+'/check'"
              :variant="getColorClass(data.value)"
              triggers="hover"
              placement="right"
            >{{data.item.invCheckMessage}}</b-tooltip>
          </span>
        </template>
        <template v-slot:cell(invNo)="data">{{data.item.invCode}}-{{data.value}}</template>

        <template v-slot:cell(actions)="row">
          <b-link @click="handleView2(row.item)" class="mr-2">查看</b-link>
          <b-link
            @click="showManualCheckDialog(row.item)"
            class="mr-2"
            v-if="row.item.invVeriResult!='1'"
          >审核</b-link>
          <b-link @click="handleDelete(row.item.id)" class="mr-1" v-if="row.item.invVeriCount==0">删除</b-link>
          <!-- <span v-if="row.item.handleStatus=='1'">无操作</span> -->
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>

    <!-- 显示手工查验对话框 -->
    <b-modal
      id="manualCheckModal"
      title="手工审核"
      incline
      v-model="manualCheckDialogVisible"
      @ok="handleManualCheck"
    >
      <template slot="modal-ok">查验</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="manualCheckForm">
          <validation-provider :rules="{required:true}" name="票种" v-slot="validationContext">
            <b-form-group label="票种" :invalid-feedback="validationContext.errors[0]">
              <b-form-select
                style="min-width:100px;"
                class="m-1"
                :options="invCataList"
                v-model="invoiceCheckDto.invCataCode"
                @change="onInvCataCodeChange"
              ></b-form-select>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="{required:false}"
            name="发票代码"
            v-slot="validationContext"
          >
            <b-form-group
              label="发票代码"
              :invalid-feedback="validationContext.errors[0]"
              label-for="input_username"
              v-if="invCodeVisiible"

            >
              <b-form-input
                v-model="invoiceCheckDto.invCode"
                :state="validateState(validationContext)"
                placeholder="请输入10-12位发票代码,数电发票无需录入"
                ref="invCode"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="{required:true, min:8, max:20}"
            name="发票号码"
            v-slot="validationContext"
          >
            <b-form-group label="发票号码" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invNo"
                :state="validateState(validationContext)"
                placeholder="请输入8位发票号码,数电发票为20位"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="{required:true, min:8,max:8}"
            name="开票日期"
            v-slot="validationContext"
          >
            <b-form-group label="开票日期(格式为YYYYMMDD)" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invIssueDate"
                :state="validateState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider :rules="{required:true}" :name="verifyAmountLable" v-slot="validationContext">
            <b-form-group :label="verifyAmountLable" :invalid-feedback="validationContext.errors[0]">
              <b-form-input
                v-model="invoiceCheckDto.invNoTaxAmount"
                :state="validateState(validationContext)"
                :placeholder="'请输入' + verifyAmountLable"
              ></b-form-input>
            </b-form-group>
          </validation-provider>

          <validation-provider :rules="{required:false, max:20}" name="校验码" v-slot="validationContext">
            <b-form-group label="校验码" :invalid-feedback="validationContext.errors[0]" v-if="invCodeVisiible">
              <b-form-input
                v-model="invoiceCheckDto.invCheckCode"
                :state="validateState(validationContext)"
                placeholder="请输入20位校验码，或者最后6位"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </validation-observer>
      </form>
    </b-modal>

    <!-- 发票上传对话框 -->
    <b-modal
      id="uploadFileModal"
      title="上传发票"
      incline
      v-model="uploadFileDialogVisible"
      @ok="handleUploadFile"
    >
      <template slot="modal-ok">立即上传</template>
      <template slot="modal-cancel">取消</template>
      <b-form-group label="文件" label-cols="3">
        <b-form-file
          v-model="uploadParam.file"
          :state="Boolean(uploadParam.file)"
          multiple
          accept="image/*, .pdf, .ofd"
          placeholder="请选择一个多个文件(单个小于1M)..."
          drop-placeholder="将文件拖放到这里..."
        ></b-form-file>
      </b-form-group>
    </b-modal>

    <!-- 手机拍照对话框 -->
    <b-modal
      id="qrCodeModal"
      title="手机扫描该二维码"
      incline
      v-model="qrCodeDialogVisible"
    >
      <p>如果在手机中无法打开该二维码，请刷新页面后重新扫码</p>
      <p>上传成功后，点击查询按钮，将会看到上传结果</p>
      <vue-qr :logoSrc="imageUrl" :text="qrCodeUrl" :size="200"></vue-qr>
    </b-modal>


  </div>
</template>

<script>
import * as invCheckFacade from "../../../api/invcheck-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import util from '@/libs/util'
import vueQr from 'vue-qr'

import { mapState } from "vuex";

import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      fileSourceList: [
        { text: "文件来源", value: "" },
        { text: "邮件", value: "邮件" },
        { text: "录入", value: "录入" },
        { text: "API", value: "API" }
      ],
      invCheckResultList: [
        { text: "审核结果", value: "" },
        { text: "未通过", value: "0" },
        { text: "通过", value: "1" }
      ],
      invCataList: [
        { text: "增值税电子普通发票", value: "10" },
        { text: "增值税电子专用发票", value: "20" },
        { text: "全电发票(增值税专用)", value: "31" },
        { text: "全电发票(增值税普通)", value: "32" },
        { text: "增值税专用发票", value: "01" },
        { text: "增值税普通发票", value: "04" }
      ],

      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      fields: [
        {
          key: "orgName",
          label: "机构"
        },
        {
          key: "fileSource",
          label: "文件",
          formatter: value => {
            return value;
          }
        },
        {
          key: "fileSubmitter",
          label: "提交人"
        },
        {
          key: "submitTime",
          label: "提交时间"
        },
        {
          key: "fileParseResult",
          label: "文件解析"
        },
        {
          key: "invVeriResult",
          label: "发票验真"
        },
        {
          key: "invCheckResult",
          label: "合规检查"
        },
        {
          key: "invVeriCount",
          label: "验真次数"
        },
        {
          key: "invNo",
          label: "发票号码"
        },
        {
          key: "invNoTaxAmount",
          label: "金额"
        },
        {
          key: "buyerName",
          label: "购方"
        },

        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          fileSource: "",
          invCheckResult: "",
          submitter: "",

          daterange: {
            startDate: addDays(new Date(), -90),
            endDate: new Date()
          },
          uploadDate: []
        },
        sortOrder: { createTime: "descending" }
      },
      //上传参数
      uploadParam: {
        file: []
      },

      // 以上为数据展示和传输对象
      invoiceCheckDto: {},
      qrCodeUrl:"",
      imageUrl: require("../../../assets/logo.png"),
      // 以下为页面状态控制参数
      showOrg: true,
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      manualCheckDialogVisible: false,
      uploadFileDialogVisible: false,
      qrCodeDialogVisible: false,
      // 以下为表单校验规则
      invCodeVisiible:true,

      // 查验金额
      verifyAmountLable: "不含税金额",

      // 以上为表单校验规则
      websock: null,
      sessionId: null, // websocket session
      wsCommandDto:{}, // 命令
    };
  },
  watch: {},
  components: {
      vueQr
  },
  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();

  },
  destroyed(){
    // 关闭socket
    this.websocketclose();
  },
  mounted() {
    // 异步加载列表数据
    this.handleQuery();
    //
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );

        // this.queryParam.criteria.timeCreated[1] = new Date(
        //   this.queryParam.criteria.timeCreated[1] + " 59:59:59"
        // );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      invCheckFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    getIconClass(status) {
      switch (status) {
        case "0":
          return "fa fa-circle text-secondary";
        case "1":
          return "fa fa-check-circle text-success";
        case "2":
          return "fa fa-times-circle text-danger";
      }
    },
    //获取显示颜色
    getColorClass(status) {
      switch (status) {
        case "0":
          return "secondary";
        case "1":
          return "success";
        case "2":
          return "danger";
      }
    },
    //查看html
    handleView(id) {
      window.open(process.env.VUE_APP_INVOICE_DOWNLOAD_PREFIX + "file/" + id);
    },
    handleView2(data) {
      window.open("./#/viewer?id=" + data.id);
    },

    // 执行查询操作
    handleQuery() {
      this.list();
    },
    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];
          if (res) {
            res.map(item => {
              let org = {};
              org.text = item.name;
              org.value = item.id;
              orgList.push(org);
            });
          }
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let entList = [{ text: "受票方", value: "" }];
          let ent = {};
          res.map(item => {
            ent.text = item.name;
            ent.value = item.id;
            entList.push(ent);
          });
          this.entList = entList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        // 表格中不显示机构信息
        this.fields.splice(0, 1);
      }
    },

    //
    showManualCheckDialog(value) {
      // let that = this;
      this.invoiceCheckDto = JSON.parse(JSON.stringify(value));
      if(this.invoiceCheckDto.invCataCode=="31" || this.invoiceCheckDto.invCataCode =="32"){
        this.invoiceCheckDto.invNoTaxAmount = this.invoiceCheckDto.totalAmount
      }
      console.log(this.invoiceCheckDto)
      this.onInvCataCodeChange(this.invoiceCheckDto.invCataCode)
      this.manualCheckDialogVisible = true;
    },

    //
    handleManualCheck(e) {
      // 调用手工审核的方法
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.manualCheckForm.validate().then(success => {
        if (!success) {
          return;
        }
        // 执行人工审核操作
        this.pageLoading = true;
        invCheckFacade
          .manualcheck(this.invoiceCheckDto)
          .then(res => {
            this.pageLoading = false;
            this.invoiceCheckDto = res;
            this.$message({
              message: "人工审核处理提交成功",
              type: "success"
            });
            this.list();
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
        this.manualCheckDialogVisible = false;
      });
    },

    // 删除
    handleDelete(val) {
      this.$bvModal
        .msgBoxConfirm("确认删除该审核记录吗？", {
          title: "删除",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确认",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            // 执行删除操作
            this.pageLoading = true;
            invCheckFacade
              .deleterow(val)
              .then(() => {
                this.pageLoading = false;
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.list();
              })
              .catch(err => {
                this.pageLoading = false;
                console.log("err", err);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 打开上传文件对话框
    showUploadFileDialog() {
      let roles = this.info.roles;
      if (roles.indexOf("sys_admin") > -1) {
        let orgId = this.queryParam.criteria.orgId;
        if (orgId == "") {
          this.$message({
            message: "机构编号不能为空，请选择一个机构",
            type: "danger"
          });
          return;
        }
      }
      this.uploadFileDialogVisible = true;
    },

    // 执行文件上传
    async handleUploadFile() {
      this.pageLoading = true;
      let orgId = this.queryParam.criteria.orgId;
      let fileList = this.uploadParam.file;

      // 文件逐个上传
      await fileList.forEach(function(file) {
        if(file.size < 1048576){
          var data = new FormData();
          data.append("orgId", orgId);
          data.append("files", file, file.name);

          // 执行文件上传
          invCheckFacade
            .uploadFile(data)
            .then(() => {
            })
            .catch(err => {
              this.pageLoading = false;
              console.log("err", err);
            });
        }else{
          console.log("文件太大，无法上传")
        }
      });

      // 上传完成后，重新刷新
      this.pageLoading = false;
      this.$message({
        message: "发票文件上传成功",
        type: "success"
      });

      this.list();
      this.uploadFileDialogVisible = false;
    },

    // 选择分类事件
    onInvCataCodeChange(item){
      if(item=="31" || item=="32"){
        this.invCodeVisiible=false
        this.verifyAmountLable='价税合计金额'
      }else{
        this.invCodeVisiible=true
        this.verifyAmountLable='不含税金额'
      }
    },

    // 显示二维码窗口
    showQrCodeDialog(){
      // 首先连接socket server
      // 建立websocket链接
      this.initWebSocket()

      //
      this.qrCodeDialogVisible = true;
    },

    // 输出二维码
    creatQrCode() {
      const token = util.cookies.get('token')
      let orgId = this.info.orgId;
      let url = process.env.VUE_APP_WEB_ROOT_PATH + "/#/camera?token=" + token + "&orgId=" + orgId
        + "&sessionId=" + this.sessionId;
      this.qrCodeUrl = url;
    },

    //初始化weosocket 
    initWebSocket() { 
      if(!this.websock){
        const wsuri = process.env.VUE_APP_WEBSOCKET_ROOT_PATH + "/eids-invoice/ws/camera";//ws地址
        console.log("正在连接ws: " + wsuri)
        this.websock = new WebSocket(wsuri); 
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onmessage = this.websocketonmessage; 
        this.websock.onclose = this.websocketclose;
      }else{
        console.log("websocket已连接")
      }
    }, 

    websocketonopen() {
      console.log("WebSocket连接成功");
    },
    websocketonerror(e) { //错误
      console.log("WebSocket连接发生错误:" + e);
      console.log(e)
    },
    websocketonmessage(e) { //数据接收 
      const redata = JSON.parse(e.data);
      // 接收数据
      if(redata.commandId=="mobileConnected"){
        console.log("手机已连接");
        this.qrCodeDialogVisible = false // 关闭弹窗
        this.$message({
          message: "您的手机已经连接，用手机拍照上传发票",
          type: "success"
        });
      }else if(redata.commandId=="fileSubmited"){
        console.log("文件已经上传")
        // 刷新表格数据
        this.$message({
          message: "接收到手机上传的文件，在列表中查看审核结果",
          type: "success"
        });
        this.list(0)
      }else if(redata.commandId=="mobileDisconnected"){
        console.log("手机连接已断开")
      }else if(redata.commandId=="sendSessionId"){
        console.log("获取SessionId:" + redata.sessionId)
        this.sessionId = redata.sessionId
        this.creatQrCode()
      }else{
        console.log("消息无法解析")
      }
    }, 

    websocketsend(agentData) {//数据发送 
      this.websock.send(agentData); 
    }, 
    websocketclose(e) { //关闭 
      console.log("connection closed (" + e + ")"); 
    },

  }
};
</script>

<style >
.actions {
  width: 150px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
.cursor {
  cursor: pointer;
}

</style>
